module.exports = __webpack_public_path__ + "img/QEF_logo_full.9d4f4e4d.png";